module.exports = __webpack_public_path__ + "static/media/sandwich.703513a8.jpg";